export const AUTH_SESSION_EXPIRED_EVENT_V104 =
  'alfredapi:session-expired:v10.4';

const AUTH_PAGE_PATHS_V104 = [
  '/login',
  '/register',
  '/reset',
  '/user/reset',
  '/oauth/github',
  '/oauth/lark',
];

let generationV104 = 0;
let expiredV104 = false;

export const getAuthGenerationV104 = () => generationV104;

export function markAuthenticatedV104() {
  generationV104 += 1;
  expiredV104 = false;
}

export function isAuthPageV104(pathname) {
  return AUTH_PAGE_PATHS_V104.includes(pathname.replace(/\/+$/, ''));
}

export function isAuthEntryRequestV104(url = '') {
  let pathname;
  try {
    pathname = new URL(url, window.location.href).pathname;
  } catch (_) {
    return false;
  }
  return /^(?:\/api\/user\/(?:login|register|reset|passkey\/login\/(?:begin|finish))|\/api\/(?:verification|reset_password|oauth\/(?:github|lark|oidc|wechat|state)))\/?$/.test(
    pathname
  );
}

function removeCachedUserV104(browser) {
  try {
    browser.localStorage.removeItem('user');
  } catch (_) {
    // The in-memory logout and auth-page guard also work with blocked storage.
  }
}

export function readCachedUserV104(browser = window) {
  try {
    if (
      browser.location.pathname.replace(/\/+$/, '') === '/login' &&
      new URLSearchParams(browser.location.search).get('expired')
    ) {
      removeCachedUserV104(browser);
      return undefined;
    }
    const stored = browser.localStorage.getItem('user');
    if (!stored) return undefined;
    const user = JSON.parse(stored);
    if (!user || typeof user !== 'object' || Array.isArray(user)) {
      removeCachedUserV104(browser);
      return undefined;
    }
    return user;
  } catch (_) {
    removeCachedUserV104(browser);
    return undefined;
  }
}

export function expireAuthSessionV104(
  requestGeneration = generationV104,
  browser = window
) {
  // A late response from a previous login must not revoke the new session.
  if (requestGeneration !== generationV104 || expiredV104) return false;
  expiredV104 = true;
  generationV104 += 1;
  removeCachedUserV104(browser);
  browser.dispatchEvent(new browser.Event(AUTH_SESSION_EXPIRED_EVENT_V104));
  if (!isAuthPageV104(browser.location.pathname)) {
    browser.location.replace('/login?expired=true');
  }
  return true;
}
